import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function GuaranteeBlock() {
  return <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{
    once: true
  }} className="text-center bg-[#111111] border border-[#D4AF37]/30 rounded-2xl max-sm:rounded-xl p-8 max-sm:p-5 md:p-12 shadow-[0_0_30px_rgba(212,175,55,0.05)]" data-id="element-65">
      <ShieldCheckIcon className="w-16 h-16 max-sm:w-12 max-sm:h-12 text-[#D4AF37] mx-auto mb-6 max-sm:mb-4" data-id="element-66" />
      <h2 className="text-3xl max-sm:text-2xl font-serif font-bold text-[#E8E0D0] mb-6 max-sm:mb-4" data-id="element-67">
        Tu compra está 100% protegida.
      </h2>
      <div className="inline-flex items-center gap-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full px-5 py-2 mb-6" data-id="element-68">
        <span className="text-[#D4AF37] font-bold text-sm uppercase tracking-wide" data-id="element-69">
          🛡️ Garantía Extendida · 30 Días
        </span>
      </div>
      <p className="text-lg text-[#A09880] mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-70">
        Por comprar ahora, obtienes{' '}
        <span className="text-[#E8E0D0] font-semibold" data-id="element-71">
          30 días de garantía extendida
        </span>
        . Si en ese tiempo sientes que no era lo que esperabas, escríbenos y te
        devolvemos cada centavo sin preguntas, sin formularios complicados, sin
        drama.
      </p>
      <p className="text-lg text-[#E8E0D0] font-medium mb-6" data-id="element-72">
        Así de seguros estamos de lo que tienes en tus manos.
      </p>
      <p className="text-xl font-serif font-bold text-[#D4AF37] italic" data-id="element-73">
        El riesgo es completamente nuestro. El beneficio es completamente tuyo.
        ✨
      </p>
    </motion.div>;
}